import { SortDirection, SortDescription } from "@/app/api/battery-portal-api";
export default class Sorter {
    sort(field) {
        let sortDirection = this.currentSort.direction;
        if (!sortDirection)
            sortDirection = SortDirection.Descending;
        else if (sortDirection == SortDirection.Ascending)
            sortDirection = SortDirection.Descending;
        else
            sortDirection = SortDirection.Ascending;
        this.setSort(field, sortDirection);
    }
    ;
    sortAscending(field) {
        this.setSort(field, SortDirection.Ascending);
    }
    ;
    sortDescending(field) {
        this.setSort(field, SortDirection.Descending);
    }
    ;
    setSort(field, direction) {
        let sort = new SortDescription({
            fieldName: field.fieldName,
            direction: direction
        });
        this.currentSort = sort;
    }
    ;
    reset() {
        this.currentSort = new SortDescription();
    }
    columnClass(fieldName) {
        const defaultClass = "sort-data";
        if (!this.currentSort)
            return defaultClass;
        if (this.currentSort.fieldName !== fieldName)
            return defaultClass;
        if (this.currentSort.direction == SortDirection.Ascending)
            return `${defaultClass}-up`;
        if (this.currentSort.direction == SortDirection.Descending)
            return `${defaultClass}-down`;
        return defaultClass;
    }
    ;
    constructor(defaultSort) {
        this.currentSort = new SortDescription();
        if (!defaultSort)
            return;
        this.currentSort = defaultSort;
    }
}
